import { useTranslation } from 'react-i18next'

import { OpportunityForm as F } from '@percent/domain/volunteering'

export function NotificationsEnabledCheckbox(props: Readonly<Omit<F.NotificationsEnabledCheckboxProps, 'label'>>) {
  const { t } = useTranslation()

  return (
    <F.NotificationsEnabledCheckbox
      {...props}
      label={t('volunteering.opportunity.form.common.attendeesSection.notificationsCheckbox.label')}
    />
  )
}
